import { useEffect, useState } from "react";

import { useAppStore } from "../../../../../context/store";
import { Dialog, CloseButton, Button, Input, Field, VStack, Spinner, Portal } from "@chakra-ui/react";
import { showToast } from "../../../../../utilies/Utility";
import Type from "../../../../../utilies/Types";
import { loadGeojsonTypeAsync } from "../../../../../utilies/loader/LoadGeojson";
import { serviceGetLayerFromPostgreSQL } from "../../../../../api/services/layer";
import { useMapObjects } from "../../../../../context/MapObjectsContext";

const ChangeSQLQuery = () => {
  // state
  const db = useAppStore((s) => s.db);
  const showChangeSQLDialog = useAppStore((s) => s.showChangeSQLDialog);
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const basicGeojsonStyle = useAppStore((s) => s.basicGeojsonStyle);
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);

  // setters / refs
  const setShowChangeSQLDialog = useAppStore.getState().setShowChangeSQLDialog;
  const viewerRef = useAppStore.getState().viewerRef;
  const { setMapObjects } = useMapObjects();
  const originalCameraControls = useAppStore.getState().originalCameraControls;

  const [isProgress, setIsProgress] = useState(false);

  const [selectedWhere, setSelectedWhere] = useState("");
  const [selectedGeometryField, setSelectedGeometryField] = useState("geom");

  useEffect(() => {
    if (showChangeSQLDialog != null) {
      setSelectedWhere(showChangeSQLDialog.sql_where);
      setSelectedGeometryField(showChangeSQLDialog.sql_geometry_field);
    }
  }, [showChangeSQLDialog]);

  const importFromPostgreSQL = () => {
    const formData = new FormData();
    formData.append(
      "params",
      JSON.stringify({
        table_name: showChangeSQLDialog.sql_table,
        schema: showChangeSQLDialog.sql_schema,
        database: db,
        limit: 1000,
        offset: 0,
        geometry_field: selectedGeometryField,
        where: selectedWhere,
      })
    );

    setIsProgress(true);
    serviceGetLayerFromPostgreSQL(formData)
      .then((res) => {
        if (res.data?.status && res.data.status === "failed") {
          showToast(res.data.message, Type.NOTIFICATION.WARNING);
        } else {
          let geojson = res.data;
          if (geojson) {
            if (geojson.features == null) geojson.features = [];
            loadGeojsonTypeAsync({
              id: showChangeSQLDialog.id,
              originalCameraControls,
              geojsonData: geojson,
              fileName: showChangeSQLDialog.file_name,
              viewerRef,
              setMapObjects,
              defaultGeojsonStyle,
              basicGeojsonStyle,
              defaultOsmStyle,
              isLoadFromDatabase: true,
              sqlSchema: showChangeSQLDialog.sql_schema,
              sqlWhere: selectedWhere,
              sqlTable: showChangeSQLDialog.sql_table,
              sqlGeometryField: selectedGeometryField,
              sqlDB: db,
              isEdited: true,
            });
            setShowChangeSQLDialog(null);
          } else {
            showToast("There is no value for the layer " + showChangeSQLDialog.file_name, Type.NOTIFICATION.WARNING);
          }
        }
      })
      .catch((err) => {
        console.error("Error", err);
      })
      .finally(() => {
        setIsProgress(false);
      });
  };

  return (
    <Dialog.Root modal={false} open={showChangeSQLDialog == null ? false : true} closeOnInteractOutside={false}>
      <Portal>
        <Dialog.Positioner style={{ pointerEvents: "none" }}>
          <Dialog.Content style={{ pointerEvents: "auto" }}>
            <Dialog.Header>
              <VStack>
                <Dialog.Title width={"full"}>Update Values</Dialog.Title>
              </VStack>
            </Dialog.Header>

            <Dialog.Body>
              <Field.Root mt={3}>
                <Field.Label>Geometry Field</Field.Label>
                <Input list="geometry-fields" placeholder="Enter ..." value={selectedGeometryField} onChange={(v) => setSelectedGeometryField(v.target.value)} />
                <datalist id="geometry-fields">
                  <option value="geom" />
                  <option value="the_geom" />
                  <option value="waypoints" />
                  <option value="location" />
                  <option value="point" />
                  <option value="trace" />
                  <option value="positon" />
                  <option value="polygon" />
                  <option value="line" />
                </datalist>
              </Field.Root>
              <Field.Root mt={3}>
                <Field.Label>Where</Field.Label>
                <Input placeholder="Enter ..." value={selectedWhere} onChange={(v) => setSelectedWhere(v.target.value)} />
              </Field.Root>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowChangeSQLDialog(null);
                  }}
                >
                  Cancel
                </Button>
              </Dialog.ActionTrigger>

              <Button onClick={importFromPostgreSQL}>{isProgress ? <Spinner /> : "Load"}</Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger
              asChild
              onClick={() => {
                setShowChangeSQLDialog(null);
              }}
            >
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ChangeSQLQuery;
